// extracted by mini-css-extract-plugin
export var component = "CardLink-module--component--RDLFv";
export var inert = "CardLink-module--inert--3pXJm";